import React from "react";
import { NavLink } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { isTournamentNavActive } from "../../utility/tournamentNav";

const TournamentBottomBar = ({
  items,
  pathname,
  onOpenMenu,
  onNavClick,
  hasNextAction = false,
  label = "Tournament",
}) => (
  <nav
    className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-brand-charcoal/10 pb-[env(safe-area-inset-bottom)]"
    aria-label={label}
  >
    <div
      className="grid h-14"
      style={{
        gridTemplateColumns: `repeat(${items.length + 1}, minmax(0, 1fr))`,
      }}
    >
      {items.map((item) => {
        const Icon = item.icon;
        const active = isTournamentNavActive(item, pathname);
        return (
          <NavLink
            key={item.name}
            to={item.href}
            end={item.isExact}
            onClick={onNavClick}
            aria-current={active ? "page" : undefined}
            className={`flex flex-col items-center justify-center gap-0.5 px-1 text-[11px] font-display font-bold tracking-wide ${
              active
                ? "bg-brand-gold/20 text-brand-charcoal"
                : "text-brand-muted"
            }`}
          >
            <Icon className="w-5 h-5 flex-shrink-0" aria-hidden="true" />
            <span className="truncate max-w-full">
              {item.mobileLabel || item.name}
            </span>
          </NavLink>
        );
      })}
      <button
        type="button"
        onClick={onOpenMenu}
        className="flex flex-col items-center justify-center gap-0.5 px-1 bg-brand-gold text-brand-charcoal text-[11px] font-display font-bold tracking-wide"
        aria-label="Show all"
      >
        <span className="relative">
          <FaBars className="w-5 h-5" aria-hidden="true" />
          {hasNextAction ? (
            <span
              className="absolute -top-1 -right-1.5 h-2 w-2 rounded-full bg-brand-charcoal"
              aria-hidden="true"
            />
          ) : null}
        </span>
        <span>Show all</span>
      </button>
    </div>
  </nav>
);

export default TournamentBottomBar;
